"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.candidateSchema = exports.candidateBaseSchema = void 0;
const zod_1 = require("zod");
const images_schema_1 = require("./images.schema");
exports.candidateBaseSchema = zod_1.z
    .object({
    id: zod_1.z.string().uuid().describe("Unique identifier of a candidate in the format of UUID"),
    references: zod_1.z
        .array(zod_1.z
        .object({
        id: zod_1.z.string().uuid().describe("Unique identifier of a reference in the format of UUID"),
        type: zod_1.z.enum(["person", "organization"]).describe("Type of a reference: either a person or an organization"),
        relationship: zod_1.z.enum(["coalition-member"]).describe("Relationship of a reference to the candidate").optional(),
    })
        .strict()
        .describe("Reference to a person or an organization"))
        .describe("Ordered list of persons or organizations that are related to the candidate"),
    displayName: zod_1.z.string().describe("Display name of a candidate").optional(),
    images: images_schema_1.imagesSchema.optional(),
    motto: zod_1.z.string().describe("Motto of a candidate").optional(),
    number: zod_1.z.number().int().describe("Official candidate list (usually drawn) number assigned by a public authority").optional(),
    rounds: zod_1.z
        .array(zod_1.z.number().int().min(1))
        .min(1)
        .refine((rounds) => new Set(rounds).size === rounds.length, { message: "Round numbers must be unique" })
        .describe("Round numbers the candidate takes part in; omitted means all rounds")
        .optional(),
    elected: zod_1.z.boolean().describe("Whether the candidate has already won the seat (e.g. in the first round)").optional(),
})
    .strict()
    .describe("Candidate for a calculator");
exports.candidateSchema = exports.candidateBaseSchema.extend({
    nestedCandidates: zod_1.z
        .array(zod_1.z.lazy(() => exports.candidateSchema))
        .describe("List of nested candidates, which can be used for aggregated answers if top-level candidate answers are not provided")
        .optional(),
});
